import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from "./router";

Vue.config.productionTip = false
Vue.use(ElementUI);

var rem = 0;
(function (doc, win) {
	var remClient = 0
	if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent))
		remClient = 18.75;
	else
		remClient = 96;
    var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function () {
        var clientWidth = docEl.clientWidth;
        rem = clientWidth / remClient;
        docEl.style.fontSize = rem + 'px';
        function adapt(){  
            var d = window.document.createElement('div');
            d.style.width = '1rem';
            d.style.display = "none";
            var head = window.document.getElementsByTagName('head')[0];
            head.appendChild(d);
            var defaultFontSize = parseFloat(window.getComputedStyle(d, null).getPropertyValue('width'));
            return defaultFontSize
        }
        rem = rem * rem / adapt();
        docEl.style.fontSize = rem + 'px'
    };
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);

new Vue({
	render: h => h(App),
	router
}).$mount('#app')
